jQuery(function($){
       
    var searchTimeoutThrottle = 500;
    var searchTimeoutID = -1;
    var currReqObj = null;
  	var $categories = $('#popup-search .categories');
    var $resultsBox = $('#popup-search .results');
  	var $loadingDiv = $('#popup-search .loading');
  	var $viewAll = $('#popup-search .view-all');
    var $noResults = $('#popup-search .no-results');
  
    $('#popup-search .formwrap input[type="text"]').bind('keyup change', function(){
        
      // only search if search string longer than 2, and it has changed
      if($(this).val().length > 2 && $(this).val() != $(this).data('oldval')) {

        // reset previous value
        $(this).data('oldval', $(this).val());

        // kill outstanding ajax request
        if(currReqObj != null) currReqObj.abort();

        // kill previous search
        clearTimeout(searchTimeoutID);

        var $form = $(this).closest('form');

        // search term
        var term = '*' + $form.find('input[name="q"]').val() + '*';

        // url for full search page
        var linkURL = $form.attr('action') + '?type=product&q=' + term;

        // show loading
        $categories.hide(0);
        $loadingDiv.show(0);
        
        // do next search (in x milliseconds)
        searchTimeoutID = setTimeout(function(){
          // ajax hit on search page
          currReqObj = $.ajax({
            url: $form.attr('action'),
            data: {
              type: 'product',
              view: 'json',
              q: term,
            },
            dataType: "json",
            success: function(data){
              $loadingDiv.hide(0);
              currReqObj = null;
              if(data.results_total == 0) {
                // no results
                $viewAll.hide(0);
                $resultsBox.empty();
                $noResults.show(0);
                $categories.show(0);
              } else {
                // numerous results
                $noResults.hide(0);
                $categories.hide(0);
                $resultsBox.empty();
                $.each(data.results, function(index, item){
                  // var xshow = 'wholesale'; // term for products we dont want to show
                  // if(!(item.title.toLowerCase().indexOf(xshow) > -1)) {
                    var $row = $('<div class="flex-item"></div>');
                    $row.append('<div class="prod"><a href="' + item.url + '"><span class="thumb"><img src="' + item.thumb + '" /></span><span class="title">' + item.title + '</span></a></div>');
                    $resultsBox.append($row);
                  // }
                });
                $viewAll.find('a').attr('href', linkURL);
                $viewAll.show(0);
              }
            }
          });
        }, searchTimeoutThrottle);
      } else if ($(this).val().length <= 2) {
        // deleted text? clear results
        $viewAll.hide(0);
        $noResults.hide(0);
        $resultsBox.empty();
        $categories.show(0);
      }
    }).attr('autocomplete', 'off').data('oldval', '').bind('focusin', function(){
        // focus, show results
        $resultsBox.fadeIn(200);
    });
  
    // search box should mimic live search string: products only, partial match
    $('#popup-search .formwrap form').on('submit', function(e){
      e.preventDefault();
      var term = '*' + $(this).find('input[name="q"]').val() + '*';
      /*var linkURL = $(this).attr('action') + '?type=product&q=' + term;*/
      var linkURL = $(this).attr('action') + '?q=' + term;
      window.location = linkURL;
    });

});